module.exports = {
	"en-tal": {
		"errors": {
			"contact": {
				"not_found": "The contact you are looking for does not exist"
			},
			"plans": {
				"free_trial": {
					"expired_title": "Your free trial has expired.",
					"expired_description": "Your Fanomena Talent account has been paused, but will be reactivated once you upgrade your plan. Please click the button below to contact us and continue using Fanomena Talent.",
					"expired_button": "Contact Sales"
				},
				"not_allowed_modal": {
					"title": "Please upgrade your plan.",
					"description": "The feature that you have selected is not available in your current plan. Please contact us via intercom chat or through the link below to connect with a member of our team who can assist in upgrading your existing plan in Fanomena Talent.",
					"button": "Contact Sales"
				},
				"not_found": "Please select a plan."
			},
			"api_error_modal": {
				"no_name": "No name",
				"select_company": "Select a company",
				"select_company_caption": "The following companies match with the domoain of the email. Please select one to continue"
			},
			"emailtemplate": {
				"name": {
					"invalid": "Please enter a name"
				},
				"body": {
					"invalid": "Please enter a body text"
				}
			},
			"externalform": {
				"name": {
					"invalid": "Please enter a name"
				},
				"language": {
					"invalid": "Please select a language"
				},
				"project_id": {
					"invalid": "Please select a campaign"
				}
			},
			"users": {
				"xls_import": {
					"wrong_file": "Please select a valid file"
				}
			},
			"organization": {
				"name": {
					"valid": "Please enter a name"
				}
			},
			"wrong_email_format": "The email is incorrect",
			"authentication": {
				"empty_firstname": "The first name is empty. Please enter a first name.",
				"empty_lastname": "The last name is empty. Please enter a last name.",
				"empty_password": "The password is empty. Please enter a password.",
				"logout": "Thank you for using Fanomena Talent, see you soon",
				"unauthorized": "Incorrect user/password combination! Could not authenticate user!",
				"wrong_email": "The email format is incorrect.",
				"wrong_jwt": "Your authentification credentials expired, please login again",
				"wrong_password": "The password is not valid. Must contain at least 8 characters, one letter and one number.",
				"wrong_password_confirmation": "The passwords do not match."
			},
			"base_score_error": "Base score should only contain numbers",
			"compatibility": {
				"webcam": {
					"ios": "iPhone doesn't support the webcam API. Please upload a picture from your gallery.",
					"safari": "Thank you for using Fanomena Talent. For full use of the product to capture new talents please download our mobile app or switch your browser to Google Chrome.",
					"firefox": "Thank you for using Fanomena Talent. Please switch your browser to Google Chrome for full use of the product to capture new talents."
				}
			},
			"external_form": {
				"json": {
					"invalid": "The json format is invalid."
				}
			},
			"lead": {
				"duplicate_email": "This email already exists",
				"email": {
					"empty": " ",
					"invalid": "The email is invalid",
					"invalid_domain": "The email domain is invalid",
					"taken": "This email address is already taken"
				},
				"phone_company": {
					"invalid": "Invalid phone number format"
				},
				"wrong_tag_format": "A tag can only contains letters and numbers"
			},
			"lead_mask": {
				"json": {
					"invalid": "The json format is invalid."
				},
				"missing_elements": {
					"firstname": "Your talent sheet is missing the \"firstname\" field. Please add it.",
					"lastname": "Your talent sheet is missing the \"lastname\" field. Please add it.",
					"email": "Your talent sheet is missing the \"email\" field. Please add it."
				},
				"missing_values": "One of your talentsheet fields is missing additional values. Please add at least one."
			},
			"leadmask": {
				"name": {
					"invalid": "Please add a name"
				},
				"language": {
					"invalid": "Please add a language"
				}
			},
			"project": {
				"category": {
					"invalid": "The category is invalid"
				},
				"end_date": {
					"invalid": "The end date is invalid"
				},
				"name": {
					"invalid": "Name is invalid"
				},
				"start_date": {
					"invalid": "The start date is invalid"
				},
				"not_found": "The campaign you were looking for could not be found",
				"lead_mask_id": {
					"invalid": "Please select a talent sheet"
				}
			},
			"server_unreachable": "The server does not respond",
			"token": {
				"invalid": "The token is invalid or expired."
			},
			"unauthorized": "The page you're trying to access is unauthorized",
			"user": {
				"duplicate_email": "The email is already registered. Please choose another.",
				"organization": {
					"invalid_plan": "The plan of this organization is either invalid or expired."
				},
				"email": {
					"empty": "The email is empty",
					"invalid": "The email is invalid"
				},
				"xls_import": {
					"wrong_file": "This file can't be used for user import."
				}
			}
		},
		"eventbaxx_event": {
			"association_mismatch": "Error-code 'eventbaxx_event.association_mismatch'. Please contact our customer support team.",
			"lead": {
				"email": {
					"invalid": "The businesskit cannot be sent because this talent's email address is not valid"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/talents/errors.en-tal.yml
// module id = 2036
// module chunks = 0